import { Auth0Client } from '@auth0/auth0-spa-js';

import authConfig from './config';

// Logging out from MODO Central (another origin) leaves our cached
// session in localStorage. Ask Auth0 (prompt=none) who the active SSO user is.

const SILENT_CHECK_TIMEOUT_SECONDS = 5;

let freshLogin = false;

// Session just issued by Auth0: skip the check (avoids a redirect loop when
// third-party cookies are blocked).
export const markFreshLogin = () => {
  freshLogin = true;
};

export const isFreshLogin = () => freshLogin;

export const resetFreshLogin = () => {
  freshLogin = false;
};

const createVerificationClient = () =>
  new Auth0Client({
    domain: authConfig.domain,
    clientId: authConfig.clientID,
    authorizationParams: {
      audience: authConfig.audience,
      redirect_uri: authConfig.redirectURI,
    },
    // Throwaway client: must not touch the main client's cache.
    cacheLocation: 'memory',
    useRefreshTokens: false,
  });

// Fails closed on any error (login_required, timeout, network).
export const isActiveSessionUser = async (expectedSub: string): Promise<boolean> => {
  try {
    const client = createVerificationClient();
    await client.getTokenSilently({ cacheMode: 'off', timeoutInSeconds: SILENT_CHECK_TIMEOUT_SECONDS });
    const activeUser = await client.getUser();
    return Boolean(activeUser?.sub) && activeUser?.sub === expectedSub;
  } catch (error) {
    console.warn('No se pudo verificar la sesión activa de Auth0', error?.error ?? error);
    return false;
  }
};
